import React, { useMemo, type FC } from 'react'

import { useAtom } from 'jotai'
import { GridCell, Select } from 'mailup-web-components'
import { useIntl, type IntlShape } from 'react-intl'

import { type DeviceType, type UiDeviceSpec } from '../../filterConditionTypes'
import { filterFormImmerAtom } from '../../state/state'
import { type ConditionProps } from '../../types'

const options = [
  {
    label: 'Android',
    value: 'SysSpec_Android',
  },
  {
    label: 'Apple iOS',
    value: 'SysSpec_Apple_iOS',
  },
  {
    label: 'Apple Mac OS',
    value: 'SysSpec_Apple_Mac_OS',
  },
  {
    label: 'Microsoft Windows',
    value: 'SysSpec_MS_Windows',
  },
  {
    label: 'Linux',
    value: 'SysSpec_Linux',
  },
  {
    label: 'Microsoft Windows Phone',
    value: 'SysSpec_MS_Windows_Phone',
  },
  {
    label: 'Symbian',
    value: 'SysSpec_Symbian',
  },
  {
    label: 'BlackBerry',
    value: 'SysSpec_BlackBerry',
  },
  //
  {
    label: 'Android',
    value: 'DeviceSpec_Android',
  },
  {
    label: 'iPhone',
    value: 'DeviceSpec_iPhone',
  },
  {
    label: 'iPad',
    value: 'DeviceSpec_iPad',
  },
  {
    label: 'PC - Windows',
    value: 'DeviceSpec_PC_Windows',
  },
  {
    label: 'PC - Apple',
    value: 'DeviceSpec_PC_Apple',
  },
  {
    label: 'PC - Linux',
    value: 'DeviceSpec_PC_Linux',
  },
  {
    label: 'Windows Phone',
    value: 'DeviceSpec_Windows_Phone',
  },
  {
    label: 'Symbian',
    value: 'DeviceSpec_Symbian',
  },
  {
    label: 'BlackBerry',
    value: 'DeviceSpec_BlackBerry',
  },
]

const getOptionGroups = (
  intl: IntlShape,
): Array<{ label: string; values: Array<UiDeviceSpec['Value']> }> => {
  return [
    {
      label: intl.formatMessage({ id: 'Load.Filters.DeviceCategoryDevice' }),
      values: [
        'DeviceSpec_Windows_Phone',
        'DeviceSpec_Symbian',
        'DeviceSpec_PC_Windows',
        'DeviceSpec_PC_Linux',
        'DeviceSpec_PC_Apple',
        'DeviceSpec_iPhone',
        'DeviceSpec_iPad',
        'DeviceSpec_BlackBerry',
        'DeviceSpec_Android',
      ],
    },
    {
      label: intl.formatMessage({ id: 'Load.Filters.DeviceCategoryOS' }),
      values: [
        'SysSpec_Symbian',
        'SysSpec_MS_Windows_Phone',
        'SysSpec_MS_Windows',
        'SysSpec_Linux',
        'SysSpec_BlackBerry',
        'SysSpec_Apple_Mac_OS',
        'SysSpec_Apple_iOS',
        'SysSpec_Android',
      ],
    },
  ]
}

const DeviceSpecCondition: FC<ConditionProps> = ({ blockIndex, condIndex }) => {
  const intl = useIntl()
  const [filter, setFilter] = useAtom(filterFormImmerAtom)
  const condition = filter.Blocks[blockIndex].Conditions[condIndex]
  const spec = condition.Spec as UiDeviceSpec

  const optionGroups = useMemo(() => getOptionGroups(intl), [intl])

  const handleChange = (value: DeviceType): void => {
    setFilter((draft) => {
      const spec = draft.Blocks[blockIndex].Conditions[condIndex]
        .Spec as UiDeviceSpec
      spec.Value = value
    })
  }

  return (
    <GridCell span={4}>
      <Select
        searchable={false}
        value={spec.Value}
        options={options}
        optionGroups={optionGroups}
        onChange={handleChange}
        placeholder={intl.formatMessage({
          id: 'Load.Filters.SelectDevicePlaceholder',
        })}
        data-mu-test='input-device'
      />
    </GridCell>
  )
}

export default DeviceSpecCondition
